import { IComparer } from "./IComparer";
import { NAMESPACE } from "./_Namespace";

function isNullOrUndefined(value: any)
{
    return value === undefined || value === null;
}

export class ObjectValueComparer<T> implements IComparer<T>
{
    public static classNamespace = NAMESPACE + "ObjectValueComparer";
    public static className = "ObjectValueComparer";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Global Variables

    public static readonly Default = new ObjectValueComparer<any>();

    // #endregion

    // #region Public Methods

    public compare(x: T, y: T): -1 | 0 | 1
    {
        if (x === y)
            return 0;

        const
            xIsNullOrUndefined = isNullOrUndefined(x), yIsNullOrUndefined = isNullOrUndefined(y);

        if (xIsNullOrUndefined && !yIsNullOrUndefined)
            return -1;

        if (!xIsNullOrUndefined && yIsNullOrUndefined)
            return 1;

        const
            properties = Object
                .getOwnPropertyNames(x ? x : {})
                .concat(Object.getOwnPropertyNames(y ? y : {}))
                .filter((item, index, array) => array.indexOf(item) === index)
                .sort();

        for (let i = 0; i < properties.length; i++)
        {
            if (Object.prototype.hasOwnProperty.call(x, properties[i]) && !Object.prototype.hasOwnProperty.call(y, properties[i]))
                return -1;
            else if (!Object.prototype.hasOwnProperty.call(x, properties[i]) && Object.prototype.hasOwnProperty.call(y, properties[i]))
                return 1;

            if ((x as any)[properties[i]] === (y as any)[properties[i]])
                continue;

            const
                xPropertyIsNullOrUndefined = (x as any)[properties[i]] === null || (x as any)[properties[i]] === undefined, yPropertyIsNullOrUndefined = (y as any)[properties[i]] === null || (y as any)[properties[i]] === undefined;

            if (xPropertyIsNullOrUndefined && !yPropertyIsNullOrUndefined)
                return -1;

            if (!xPropertyIsNullOrUndefined && yPropertyIsNullOrUndefined)
                return 1;

            return (x as any)[properties[i]] < (y as any)[properties[i]] ? -1 : 1;
        }

        return 0;
    }

    // #endregion
}